/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiagLabInventoryType } from 'app/shared/model/diag-lab-inventory-type.model';
import { IDiagLabInventoryBill } from 'app/shared/model/diag-lab-inventory-bill.model';

export interface IDiagLabInventory {
  id?: string;
  brandId?: string | null;
  batchNumber?: string | null;
  serialNumber?: string;
  stockQty?: number | null;
  manufacDate?: number | null;
  expDate?: number | null;
  taxCode?: string | null;
  mrp?: number | null;
  price?: number | null;
  remainingQuantity?: number | null;
  avgUsesPerItem?: number | null;
  packs?: number | null;
  HSNCode?: string | null;
  rack?: string | null;
  discount?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  diagLab?: IDiagLab | null;
  type?: IDiagLabInventoryType | null;
  bill?: IDiagLabInventoryBill | null;
}

export const defaultValue: Readonly<IDiagLabInventory> = {
  active: false,
};
